const state = {
  // User Info
  user: {},
  // ConnectWalletCommunication
  wc: null,
  // WebSocket communication
  ws: null,
  // Trading price
  tradingPrice: "",
  // chain system information
  chainSystemInfo: {},
  feeConfigsInfo: {},
  boxTradingPairShow: false,
  COMMUNITY: [
    // { icon: "forum", name: "Forum", link: "https://forum.functionx.io" },
    {
      icon: "telegram",
      name: "Telegram",
      link: "https://t.me/+GiT9MPWQaPU2ZGU9",
    },
    {
      icon: "youtube",
      name: "YouTube",
      link: "https://www.youtube.com/channel/UCJ8ggaUjfS5at6_toTJM8yg",
    },
    // {
    //   icon: "medium",
    //   name: "Medium",
    //   link: "https://medium.com/functionx",
    // },
    // {
    //   icon: "facebook",
    //   name: "Facebook",
    //   link: "https://facebook.com/FunctionX.io/",
    // },
    {
      icon: "twitter",
      name: "Twitter",
      link: "https://twitter.com/marginx_io",
    },
    {
      icon: "discord",
      name: "Discord",
      link: "https://discord.com/invite/7yUjqadZFq",
    },
    { icon: "github", name: "Github", link: "https://github.com/marginxio" },
    { icon: "email", name: "Email", link: "mailto:hello@marginx.io" },
  ],
};

export default state;
